import React from 'react';
import cx from 'classnames';
import Typography from '@/components/shared/Typography';

const FeaturedIn: React.FC = () => {
  return (
    <div
      className={cx(
        'pt-11 pb-34 bg-green flex flex-col justify-center items-center xl:pt-18 xl:pb-94'
      )}
    >
      <Typography
        color="white"
        style={{
          fontFamily: 'Libre Baskerville',
          fontSize: 32,
          fontStyle: 'normal',
          fontWeight: 700,
          letterSpacing: 0,
          textAlign: 'center'
        }}
      >
        Featured in
      </Typography>
      <div
        className={cx(
          'flex flex-col xl:flex-row w-full items-center justify-center xl:mt-13'
        )}
      >
        <div className={cx('xl:mr-60 mt-60 xl:mt-0')}>
          <img src="/images/featuredIn/bbb-spark-award.png" alt="bbb spark" />
        </div>
        <div className={cx('mt-10 xl:mt-0')}>
          <img
            src="/images/featuredIn/the-new-york-times.png"
            alt="new york times"
          />
        </div>
        <div className={cx('xl:mx-60 mt-10 xl:mt-0')}>
          <img src="/images/featuredIn/wral-news.png" alt="wral-news" />
        </div>
        <div className={cx('mt-10 xl:mt-0')}>
          <img src="/images/featuredIn/earfluence.png" alt="earfluence" />
        </div>
        <div className={cx('xl:ml-60 mt-10 xl:mt-0')}>
          <img src="/images/featuredIn/grep-beat.png" alt="grep beat" />
        </div>
        <div className={cx('xl:ml-60')}>
          <img
            src="/images/featuredIn/miami-university.png"
            alt="miami university"
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturedIn;
